import EventBus from '@/scripts/event-bus';

export const EXIT_SURVEY_DETAILS_WIDGET_NAME = 'exit-survey-details-widget';

export function openExitSurveyDetailsWidget(config) {
  return EventBus.$emit('open-widget', {
      name: EXIT_SURVEY_DETAILS_WIDGET_NAME,
      config: {
        id: config.id
      },
  });
}
